import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loggedIn: false,
		user: null,
		loaderCount: 0,
		breadcrumbs: []
	},
	mutations: {
		setLoggedIn(state, value) {
			state.loggedIn = value;
		},
		setUser(state, value) {
			state.user = value;
		},
		increaseLoaderCount(state) {
			setTimeout(() => {
				state.loaderCount++;
			}, 200);
		},
		decreaseLoaderCount(state) {
			state.loaderCount--;
		},
		setBreadcrumbs(state, value) {
			state.breadcrumbs = value;
		}
	}
})
